import React, { useState, useEffect, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import "jspdf-autotable";

const AgentDirectReport = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [type, setType] = useState([]);
    const [leaseType, setLeaseType] = useState([]);
    const [reason, setReason] = useState([]);

    const [formData, setFormData] = useState({
        property: "",
        type: "",
        leaseType: "",
        reason: "",
        from: "",
        to: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        let todate = formatDate(today)
        setFormData((prev) => ({ ...prev, to: todate, from: todate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRSearchPropertyNos,LRAgentDirectSearchLeaseType,LRAgreeSearchType,LRAgreeSearchReason');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.PropertyNo)
            setLeaseType(res?.data?.dropdowns?.LRAgentDirectSearchLeaseType)
            setType(res?.data?.dropdowns?.LRAgreeSearchType)
            setReason(res?.data?.dropdowns?.LRAgreeSearchReason)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("FromDate", formData?.from || todate);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("LeaseType", formData?.leaseType?.label || "All");
            params.append("Type", formData?.type?.label || "All");
            params.append("Reason", formData?.reason?.label || "All");

            const res = await apiService.getApiParamater("REPORT_AGENT_DIRECT", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                getAllItems(res.data.paginationData)
                setPagination(res.data.paginationData);
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("FromDate", formData?.from || todate);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("LeaseType", formData?.leaseType?.label || "All");
            params.append("Type", formData?.type?.label || "All");
            params.append("Reason", formData?.reason?.label || "All");
            const res = await apiService.getApiParamater("REPORT_AGENT_DIRECT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getPercent = (value, total) => {
        if (!total) return "0%";
        return `${((Number(value || 0) / Number(total)) * 100).toFixed(2)}%`;
    }
    const columnDefs = [
        { headerName: "Property", field: "propertyNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130, },
        { headerName: "Property Name", field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 200, },
        { headerName: "Unit Move Out", field: "unitsMoveOut", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Unit Move In", field: "unitsMoveIn", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Direct", field: "unitsThroughAgent", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "%", field: "unitsThroughAgent", valueGetter: (params) => getPercent(params.data?.unitsThroughAgent, params.data?.unitsMoveIn), filter: true, floatingFilter: true, suppressMovable: true, width: 80, },
        { headerName: "Internal Agent", field: "unitsThroughInternalAgent", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "%", field: "unitsThroughInternalAgent", valueGetter: (params) => getPercent(params.data?.unitsThroughInternalAgent, params.data?.unitsMoveIn), filter: true, floatingFilter: true, suppressMovable: true, width: 80, },
        { headerName: "External Agent", field: "unitsThroughExternalAgent", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "%", field: "unitsThroughExternalAgent", valueGetter: (params) => getPercent(params.data?.unitsThroughExternalAgent, params.data?.unitsMoveIn), filter: true, floatingFilter: true, suppressMovable: true, width: 80, },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setFormData({
            property: "",
            type: "",
            leaseType: "",
            reason: "",
            from: todate,
            to: todate,
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";

        if (value === 0 || value === "0") return "";

        return value;
    };
    const exportExcel = () => {
        if (!exportData || !Array.isArray(exportData) || exportData.length === 0) {
            console.warn("No export data available");
            return;
        }

        const columns = [
            {
                header: "Property",
                dataKey: "propertyNo",
                width: 15,
            },
            {
                header: "Property Name",
                dataKey: "propertyName",
                width: 30,
            },
            {
                header: "Unit Move Out",
                dataKey: "unitsMoveOut",
                width: 18,
            },
            {
                header: "Unit Move In",
                dataKey: "unitsMoveIn",
                width: 18,
            },
            {
                header: "Direct",
                dataKey: "unitsThroughAgent",
                width: 15,
            },
            {
                header: "%",
                dataKey: "directPercentage",
                width: 12,
            },
            {
                header: "Internal Agent",
                dataKey: "unitsThroughInternalAgent",
                width: 20,
            },
            {
                header: "%",
                dataKey: "internalAgentPercentage",
                width: 12,
            },
            {
                header: "External Agent",
                dataKey: "unitsThroughExternalAgent",
                width: 20,
            },
            {
                header: "%",
                dataKey: "externalAgentPercentage",
                width: 12,
            },
        ];

        const excelData = exportData.map((item) => {
            return {
                Property: normalizeValue(item?.propertyNo),

                "Property Name": normalizeValue(item?.propertyName),

                "Unit Move Out": normalizeValue(item?.unitsMoveOut),

                "Unit Move In": normalizeValue(item?.unitsMoveIn),

                Direct: normalizeValue(item?.unitsThroughAgent),

                "%": getPercent(
                    item?.unitsThroughAgent,
                    item?.unitsMoveIn
                ),

                "Internal Agent": normalizeValue(
                    item?.unitsThroughInternalAgent
                ),

                // Internal Agent %
                // Since there are duplicate "%" headers,
                // this needs to be handled separately below.
                "Internal Agent %": getPercent(
                    item?.unitsThroughInternalAgent,
                    item?.unitsMoveIn
                ),

                "External Agent": normalizeValue(
                    item?.unitsThroughExternalAgent
                ),

                "External Agent %": getPercent(
                    item?.unitsThroughExternalAgent,
                    item?.unitsMoveIn
                ),
            };
        });

        // Use unique Excel headers for percentage columns
        const finalExcelData = excelData.map((row) => ({
            Property: row.Property,
            "Property Name": row["Property Name"],
            "Unit Move Out": row["Unit Move Out"],
            "Unit Move In": row["Unit Move In"],
            Direct: row.Direct,
            "% Direct": row["%"],
            "Internal Agent": row["Internal Agent"],
            "% Internal Agent": row["Internal Agent %"],
            "External Agent": row["External Agent"],
            "% External Agent": row["External Agent %"],
        }));

        const headers = [
            "Property",
            "Property Name",
            "Unit Move Out",
            "Unit Move In",
            "Direct",
            "% Direct",
            "Internal Agent",
            "% Internal Agent",
            "External Agent",
            "% External Agent",
        ];

        const dataRows = finalExcelData.map((row) => headers.map((h) => row[h]));

        const worksheet = XLSX.utils.aoa_to_sheet([
            ["AGENT DIRECT REPORT"],
            headers,
            ...dataRows,
        ]);

        // Merge title row across all columns
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
        ];

        // Set Excel column widths
        worksheet["!cols"] = [
            { wch: 15 }, // Property
            { wch: 30 }, // Property Name
            { wch: 18 }, // Unit Move Out
            { wch: 18 }, // Unit Move In
            { wch: 15 }, // Direct
            { wch: 12 }, // % Direct
            { wch: 20 }, // Internal Agent
            { wch: 18 }, // % Internal Agent
            { wch: 20 }, // External Agent
            { wch: 18 }, // % External Agent
        ];

        worksheet["!rows"] = [{ hpt: 28 }, { hpt: 30 }];
        worksheet["!freeze"] = { ySplit: 2 };

        const borderStyle = {
            top: { style: "thin", color: { rgb: "FFD9D9D9" } },
            bottom: { style: "thin", color: { rgb: "FFD9D9D9" } },
            left: { style: "thin", color: { rgb: "FFD9D9D9" } },
            right: { style: "thin", color: { rgb: "FFD9D9D9" } },
        };

        // Title row
        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        // Column header row
        headers.forEach((header, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF666666" } },
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                border: borderStyle,
            };
        });

        // Data rows
        dataRows.forEach((row, r) => {
            headers.forEach((header, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;
                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: "center" },
                    border: borderStyle,
                    fill: { fgColor: { rgb: r % 2 === 0 ? "FFFFFFFF" : "FFF5F2F8" } },
                };
            });
        });

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Agent Direct Report"
        );

        XLSX.writeFile(
            workbook,
            "Agent_Direct_Report.xlsx"
        );
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group row">
                            <div className="col d-flex">
                                <label className="form-label w-0">From Date</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="col d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="col d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.type}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                                    options={type?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="col">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-100'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-100">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="form-group row mt-2">
                            <div className="col d-flex">
                                <label className="form-label w-0">To Date</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="col d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseType', value: selectedOption })}
                                    options={leaseType?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="col d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Termination Reason</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.reason}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'reason', value: selectedOption })}
                                    options={reason?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="col">
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-100">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Agent Direct Report</h5>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default AgentDirectReport;